import { useEffect } from "react";
import { useUnmount } from "react-use";
import { MutationState } from "../store/modules/types";

export const useMutation = <T extends unknown>({
  mutation: { loading, item, error },
  clear,
  onSuccess,
  onError,
}: {
  mutation: MutationState<T>;
  clear: () => void;
  onSuccess?: (item: T) => void;
  onError?: (error: string) => void;
}) => {
  useEffect(() => {
    if (!loading && item && onSuccess) {
      onSuccess(item);
      clear();
    }
    if (!loading && error && onError) {
      onError(error);
      clear();
    }
  }, [loading, error, item, clear, onError, onSuccess]);

  useUnmount(() => clear());
};
